export default {
    updateBankInfo({commit}, { bank, accountNumber, clabe }) {
      commit("UPDATE_BANK_DATA", { bank, accountNumber, clabe });
   }
}
